// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company_company__53V9D {
  position: absolute;
  border-radius: 50%;
  transition: top 1.5s ease-out, left 1.5s ease-out, opacity 1s ease-out,
    border 0.3s ease-in-out;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  cursor: pointer;
}

.company_initialPosition__7sPkb {
  opacity: 0;
}

.company_animate__5MBEs {
  opacity: 1;
}

.company_companyTitle__exs6C {
  font-weight: 700;
  color: #98adb0;
  font-size: 0.75rem;
  text-transform: uppercase;
  margin-top: 120px;
  white-space: nowrap;
  overflow: visible;
  text-align: center;
  position: absolute;
  bottom: -5;
  left: 50%;
  transform: translateX(-50%);
}

.company_company__53V9D:hover {
  border: 3px solid #fde63b;
  padding: 2px;
}

@media (max-width: 1024px) {
  /* Changed from 1025px to 1024px */
  .company_company__53V9D {
    position: relative;
    transition: opacity 2s ease-out, border 1s ease-in-out;
    top: auto !important;
    left: auto !important;
    margin: 20px auto;
  }

  .company_initialPosition__7sPkb {
    opacity: 0;
  }

  .company_animate__5MBEs {
    opacity: 1;
  }
  .company_companySection__Kvb6X {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .company_companyTitle__exs6C {
    font-size: 1rem;
    margin-top: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/COMPANIES/company.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;2BACyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC;IACE,kBAAkB;IAClB,sDAAsD;IACtD,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".company {\n  position: absolute;\n  border-radius: 50%;\n  transition: top 1.5s ease-out, left 1.5s ease-out, opacity 1s ease-out,\n    border 0.3s ease-in-out;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center;\n  cursor: pointer;\n}\n\n.initialPosition {\n  opacity: 0;\n}\n\n.animate {\n  opacity: 1;\n}\n\n.companyTitle {\n  font-weight: 700;\n  color: #98adb0;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  margin-top: 120px;\n  white-space: nowrap;\n  overflow: visible;\n  text-align: center;\n  position: absolute;\n  bottom: -5;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.company:hover {\n  border: 3px solid #fde63b;\n  padding: 2px;\n}\n\n@media (max-width: 1024px) {\n  /* Changed from 1025px to 1024px */\n  .company {\n    position: relative;\n    transition: opacity 2s ease-out, border 1s ease-in-out;\n    top: auto !important;\n    left: auto !important;\n    margin: 20px auto;\n  }\n\n  .initialPosition {\n    opacity: 0;\n  }\n\n  .animate {\n    opacity: 1;\n  }\n  .companySection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .companyTitle {\n    font-size: 1rem;\n    margin-top: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"company": `company_company__53V9D`,
	"initialPosition": `company_initialPosition__7sPkb`,
	"animate": `company_animate__5MBEs`,
	"companyTitle": `company_companyTitle__exs6C`,
	"companySection": `company_companySection__Kvb6X`
};
export default ___CSS_LOADER_EXPORT___;
